/**
 * Created by B032151 on 1/9/2017.
 */
import createReactClass from 'create-react-class';
import moment from 'moment';
import React from 'react';
import Constants from '../constants/constants';

import { Button, Modal } from 'react-bootstrap';
import { dispatcher } from '../dispatcher/dispatcher';

const { ActionTypes } = Constants;
import { userStore } from '../stores/user';

var timerInterval;

function getStateFromStores() {
    return {
        activeOverride: userStore.getActiveOverride(),
        expiredOverride: userStore.getExpiredOverride(),
        showModal: false,
        expiredByAdmin: userStore.getOverrideExpiredByAdminFlag(),
        timeLeft: "Override Received"
    }
}

function getOverrideTimeRemaining(expireTime) {
    var t = expireTime.diff(moment());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
        'total': t,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
    };
}

export const OverrideUserDisplayView = createReactClass({
    componentDidMount: function () {
        userStore.subscribe(this._onChange);
    },

    componentWillUpdate: function (nextProps, nextState) {
        //If we did not have an override and a new one comes in, start the timer
        if (this.state.activeOverride == null && nextState.activeOverride != null) {
            timerInterval = setInterval(() => this.tick(), 1000);
        }
        else if (this.state.expiredOverride == null && nextState.expiredOverride != null) { //If we had an override that expired, show expired message for a set amount of time
            if (nextState.expiredByAdmin)  //If expired early by an admin, clear the timer
                clearInterval(timerInterval);
            setTimeout(this.closeExpired, 30000);
        }
        else if (nextState.expiredOverride == null && nextState.activeOverride == null) { //This means that an item has been submitted, so clear the timer
            clearInterval(timerInterval);
        }
    },

    componentWillUnmount: function () {
        userStore.unsubscribe(this._onChange);
        clearInterval(timerInterval);
    },

    getInitialState: function () {
        return getStateFromStores();
    },

    tick: function () {
        var t = getOverrideTimeRemaining(this.state.activeOverride.expireTimeStamp);
        if (t.total <= 0) {
            clearInterval(timerInterval);
            dispatcher.dispatch({
                type: ActionTypes.OVERRIDE_EXPIRED,
                override: JSON.stringify(this.state.activeOverride),
                fromAdmin: false
            });
            dispatcher.dispatch({
                type: ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED,
                value: false
            });
        }
        var newTime = "Override: " + ('0' + t.minutes).slice(-2) + ':' + ('0' + t.seconds).slice(-2);
        this.setState({ timeLeft: newTime });
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    openModal() {
        this.setState({ showModal: true });
    },

    closeModal() {
        this.setState({ showModal: false });
    },

    closeExpired() {
        dispatcher.dispatch({
            type: ActionTypes.OVERRIDE_CLEAR_EXPIRED
        });
    },

    render: function () {
        var override = this.state.activeOverride;
        var overrideUserDisplay = "";

        if (override != null) {
            overrideUserDisplay = (
                <div id="overrideUserDisplayDiv">
                    <div onClick={this.openModal}>{this.state.timeLeft}</div>

                    <Modal bsSize="large"
                        backdrop='static'
                        onHide={this.closeModal}
                        show={this.state.showModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Active Override</Modal.Title>
                        </Modal.Header>

                        <div className='modal-body'>
                            Override Sub: {override.subdivision} <br />
                            Start MP: {override.startMp} {override.startMpSuffix ? override.startMpSuffix : ""}<br />
                            End MP: {override.endMp} {override.endMpSuffix ? override.endMpSuffix : ""}<br />
                            Number of Items Requested: {override.numberRequested}<br />
                            Number of Items Submitted: {override.numberSubmitted}<br />
                            Reason: {override.reasonCode + ": " + override.reasonDescription}<br />
                        </div>
                        <div className='modal-footer'>
                            <Button id="overrideModalCloseButton" bsStyle='primary'
                                onClick={this.closeModal}>Close</Button>
                        </div>
                    </Modal>
                </div>
            );
        }
        else if (this.state.expiredOverride != null) {
            if (this.state.expiredByAdmin) {
                overrideUserDisplay = (
                    <div id="overrideUserDisplayDiv">
                        <div onClick={this.closeExpired}>Override Was Expired By An Admin</div>
                    </div>
                )
            }
            else {
                overrideUserDisplay = (
                    <div id="overrideUserDisplayDiv">
                        <div onClick={this.closeExpired}>Override Has Expired</div>
                    </div>
                )
            }
        }

        return (
            <div>
                {overrideUserDisplay}
            </div>
        );
    }
});
